if (!customElements.get('add-to-cart-button')) {

  class AddToCartButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick);
    }

    handleClick(e) {
      e.preventDefault();
      console.log('Add to cart button clicked');
      
      const productId = this.getAttribute('product');
      if (!productId) {
        console.error('Product ID not found');
        return;
      }

      // Show loading state
      this.setLoadingState(true);

      // Prepare form data for Shopify AJAX API
      const formData = new FormData();
      formData.append('id', productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      // Add to cart using Shopify AJAX API
      fetch(theme.routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Product added to cart:', data);
        
        // Rerender cart sections using the same method as product.js
        this.renderCartContents(data);
        
        // Dispatch custom events for cart updates
        dispatchCustomEvent('cart:item-added', {
          product: data.hasOwnProperty('items') ? data.items[0] : data
        });
        
        this.dispatchEvent(new CustomEvent('product-added-to-cart', { 
          detail: { product: data },
          bubbles: true 
        }));
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
        // Handle error - you might want to show an error message
      })
      .finally(() => {
        // Reset loading state
        this.setLoadingState(false);
      });
    }

    setLoadingState(isLoading) {
      const button = this.querySelector('button');
      const label = this.querySelector('.add-to-cart-button-label');
      const loadingOverlay = this.querySelector('.loading-overlay');

      if (isLoading) {
        button.disabled = true;
        label.style.display = 'none';
        loadingOverlay.style.opacity = '1';
      } else {
        button.disabled = false;
        label.style.display = 'block';
        loadingOverlay.style.opacity = '0';
      }
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    renderCartContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      // Open cart drawer after adding product
      const body = document.body;
      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer && search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    connectedCallback() {
      console.log("CONNECTED - ADD TO CART BUTTON");
    }
    disconnectedCallback() {
      console.log("DISCONNECTED - ADD TO CART BUTTON");
    }

  }

  customElements.define('add-to-cart-button', AddToCartButton);
}